module.exports = __webpack_public_path__ + "static/media/desautels_mcca_logo.b4b84738.jpg";